import { Alert, Chip, List, ListItemButton, ListItemText } from '@mui/material';
import { LINE_IMPACT } from '../../../lib/packingListEditImpact';

/**
 * 수정 모드 검수 화면 상단의 배분 영향 목록. 배분된 라인의 수량·단위를 고치면 그 영향을 라인별로 보여주고, 누르면 그 라인으로 간다.
 * 고친 배분 라인이 없으면 아무것도 그리지 않는다. 수정 중이라는 표시는 헤더의 Editing 칩이 맡는다.
 */
export default function EditModeBanner({ notes, onJump }) {
    if (notes.length === 0) return null;
    return (
        <Alert severity="info" icon={false} sx={{ py: 0.25, fontSize: 12, borderRadius: 0, bgcolor: '#eef6e5', color: '#01354d', '& .MuiAlert-message': { width: '100%' } }}>
            <List dense disablePadding sx={{ maxHeight: 96, overflowY: 'auto' }}>
                {notes.map((note) => (
                    <ListItemButton key={note.lineId} onClick={() => onJump(note.lineId)} sx={{ py: 0.125, px: 1, borderRadius: 1, bgcolor: 'rgba(255,255,255,0.7)', mb: 0.25 }}>
                        <Chip size="small" label={note.kind === LINE_IMPACT.UNALLOCATE ? 'UNALLOCATE' : 'ALLOCATION'} color={note.kind === LINE_IMPACT.UNALLOCATE ? 'warning' : 'default'} sx={{ fontSize: 9, height: 16, mr: 1, '& .MuiChip-label': { px: 0.75 } }} />
                        <ListItemText primary={`Line ${note.lineNo}${note.description ? ` · ${note.description}` : ''}: ${note.message}`} primaryTypographyProps={{ fontSize: 12, noWrap: true }} sx={{ my: 0 }} />
                    </ListItemButton>
                ))}
            </List>
        </Alert>
    );
}
